import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { s3baseUrl } from "src/config/config";
import { htmlDecode } from "src/utils/convertHtml";
import { ExerciseListingApi } from "src/DAL/exercise/exercise";
import InfiniteScroll from "react-infinite-scroll-component";
import ExerciseFilter from "./ExerciseFilterNew";
import RecordNotFound from "src/components/GeneralComponents/RecordNotFound";
import CustomDrawer from "src/components/FormsDrewer/CustomDrawer";
import { gr } from "src/design-system/tokens";
import icons from "src/design-system/icons";
import GrIcon from "src/design-system/components/GrIcon";
import GrIconButton from "src/design-system/components/GrIconButton";
import GrButton from "src/design-system/components/GrButton";
import GrSearch from "src/design-system/components/GrSearch";
import GrFilterChips from "src/design-system/components/GrFilterChips";
import GrMediaCard from "src/design-system/components/GrMediaCard";
import GrCountBadge from "src/design-system/components/GrCountBadge";
import GrLoader from "src/design-system/components/GrLoader";

// Exercise list popup (pick an exercise for a workout / extra work): header with search, Filters
// and close; A-Z / Z-A; a grid of exercise cards (photo or a workout icon, name).
const headerSx = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: gr.space[3],
  padding: `${gr.space[5]} ${gr.space[6]} ${gr.space[4]}`,
  "@media (max-width: 599.95px)": { padding: `${gr.space[4]} ${gr.space[4]} ${gr.space[3]}` },
};
const titleSx = {
  m: 0,
  fontFamily: gr.font.family,
  fontSize: gr.font.size.xl,
  fontWeight: gr.font.weight.medium,
  color: gr.color.brandStrong,
};
const toolsSx = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: gr.space[2],
  "@media (max-width: 599.95px)": { width: "100%" },
};
const searchSx = { width: { xs: "100%", sm: 240 }, flex: { xs: "1 1 100%", sm: "none" } };
const gridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "repeat(2, minmax(0, 1fr))",
    sm: "repeat(3, minmax(0, 1fr))",
    md: "repeat(4, minmax(0, 1fr))",
  },
  gap: gr.space[4],
  // Room for the cards' hover border and focus ring inside the scroll box.
  p: gr.space[1],
};

const tabs = {
  all: "",
  asc: "asc",
  close: "desc",
  trash: "trash",
};
function ToshowExercise({ open, setOpen, handleChange }) {
  const handleCloseDialog1 = () => {
    setOpen(false);
    localStorage.removeItem("WorkoutExerciseListSearch");
    setFilterState(EMPTY_FILTER);
    setFilterCount(0);
    setFilterName("");
  };

  const [selectedTab, setSelectedTab] = useState(tabs.asc);
  const [exercise, setExercise] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filterName, setFilterName] = useState("");
  const [oldFilterName, setOldFilterName] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [conditionMetOnce, setConditionMetOnce] = useState(false);

  const EMPTY_FILTER = {
    exercises: [],
    mainMuscle: [],
    difficulty: [],
    search_text: "",
    exercise_type: null,
  };

  const [filterState, setFilterState] = useState(EMPTY_FILTER);
  const [filterStateUpdated, setFilterStateUpdated] = useState({});

  const searchFunction = () => {
    setPage(0);
    filterState.search_text = filterName;
    getExerciseList(filterState);
    localStorage.setItem(
      "WorkoutExerciseListSearch",
      JSON.stringify(filterState),
    );

    handleCloseFilterDrawer();
    setIsLoading(true);
  };

  const handleClearFilter = () => {
    let clear_data = { ...EMPTY_FILTER };
    setPage(0);
    setFilterName("");
    setFilterState(clear_data);
    getExerciseList(clear_data);
    handleCloseFilterDrawer();
    setIsLoading(true);
    localStorage.removeItem("WorkoutExerciseListSearch");
  };
  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
    setFilterState(filterStateUpdated);
  };

  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const handleSelectExercise = (value) => {
    handleChange(value);
    handleCloseDialog1();
    localStorage.removeItem("WorkoutExerciseListSearch");
    setFilterState(EMPTY_FILTER);
    setFilterCount(0);
    setFilterName("");
  };

  const fetchMoreData = () => {
    setPage((prev) => prev + 1);
  };

  useEffect(() => {
    if (filterName !== oldFilterName) {
      setOldFilterName(filterName);
    }
  }, [filterName]);

  const getExerciseList = async (filterData) => {
    setOldFilterName(filterName);
    let postdata = {
      difficulty: filterData.difficulty,
      exercise: filterData.exercises,
      main_muscle: filterData.mainMuscle,
      exercise_type: filterData?.exercise_type
        ? filterData?.exercise_type._id
        : "",
    };
    let result = await ExerciseListingApi(
      page,
      rowsPerPage,
      filterName,
      postdata,
      selectedTab,
    );
    if (result.code == 200) {
      let filtersCount =
        filterData?.difficulty.length +
        filterData?.exercises.length +
        filterData?.mainMuscle.length;
      setFilterCount(
        filterData?.difficulty.length +
          filterData?.exercises.length +
          filterData?.mainMuscle.length,
      );
      if (filterData?.status) {
        setFilterCount((values) => values + 1);
        filtersCount = filtersCount + 1;
      }
      if (filterData?.exercise_type) {
        setFilterCount((values) => values + 1);
        filtersCount = filtersCount + 1;
      }
      let chipData = { ...filterData };
      if (chipData.search_text) {
        delete chipData.search_text;
      }
      setFilterStateUpdated(chipData);
      setIsLoading(false);
      const newData = result?.exercises;
      setTotalCount(result.total_exercises);
      // Check if newData is an array and has data
      if (!filtersCount && !filterCount && !filterName) {
        setConditionMetOnce(false);
      }
      if ((filtersCount || filterCount || filterName) && !conditionMetOnce) {
        setExercise(result?.exercises);
        setPage(0);
        setConditionMetOnce(true);
        return;
      } else {
        let mergedData;
        if (page === 0) {
          mergedData = newData;
        } else {
          mergedData = [...exercise, ...newData];
        }

        let sortedMergedData = [...mergedData];
        let sortedMergedDataagain = [...mergedData];
        if (selectedTab === "asc") {
          sortedMergedData.sort((a, b) => {
            // Customize the comparison logic based on your data structure
            // Assuming you want to sort based on some property like title
            return a.title.localeCompare(b.title);
          });
        } else if (selectedTab === "desc") {
          sortedMergedData.sort((a, b) => {
            // Customize the comparison logic based on your data structure
            // Assuming you want to sort based on some property like title
            return b.title.localeCompare(a.title);
          });
        }
        if (filterName) {
          const word = filterName.toLowerCase();
          sortedMergedData.sort((a, b) => {
            const startsWithA = a.title.toLowerCase().startsWith(word);
            const startsWithB = b.title.toLowerCase().startsWith(word);

            // If only one of them starts with the search term, that one should come first
            if (startsWithA && !startsWithB) {
              return -1;
            }
            if (!startsWithA && startsWithB) {
              return 1;
            }
            // If neither or both start with the search term, sort alphabetically
            return a.title.localeCompare(b.title);
          });
        }

        if (filterName !== "") {
          setExercise(sortedMergedDataagain);
        } else {
          setExercise(sortedMergedData);
        }
      }
    }
  };

  useEffect(() => {
    if (open) {
      let filter_data = EMPTY_FILTER;
      let find_filter = localStorage.getItem("WorkoutExerciseListSearch");
      if (find_filter) {
        filter_data = JSON.parse(find_filter);
        if (filter_data.search_text) {
          setFilterName(filter_data.search_text);
        }
      }
      setFilterState(filter_data);
      setFilterStateUpdated(filter_data);
      getExerciseList(filter_data);
    }
  }, [page, rowsPerPage, open, selectedTab]);

  useEffect(() => {
    let filter_data = EMPTY_FILTER;
    let find_filter = localStorage.getItem("WorkoutExerciseListSearch");
    if (find_filter) {
      filter_data = JSON.parse(find_filter);
    }
    setFilterState(filter_data);
    setFilterStateUpdated(filter_data);
    const timer = setTimeout(() => {
      setPage(0);
      getExerciseList(filter_data);
    }, 500);

    return () => clearTimeout(timer);
  }, [filterName]);

  useEffect(() => {
    setIsLoading(true);
    setPage(0);
    setExercise([]);
  }, [selectedTab, open]);

  // While searching, the list keeps the search order (A-Z / Z-A do nothing, as before).
  const sortValue = filterName !== "" ? "" : selectedTab;

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseDialog1}
        fullWidth
        maxWidth="md"
        BackdropProps={{ sx: { background: gr.color.overlay } }}
        PaperProps={{
          sx: {
            minHeight: 550,
            borderRadius: gr.radius.card,
            boxShadow: gr.shadow.raised,
            backgroundImage: "none",
            fontFamily: gr.font.family,
            color: gr.color.ink,
          },
        }}
      >
        <Box sx={headerSx}>
          <Box component="h2" sx={titleSx}>
            Exercises
          </Box>
          <Box sx={toolsSx}>
            <GrSearch
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}
              onClear={() => setFilterName("")}
              placeholder="Search"
              label="Search"
              sx={searchSx}
            />
            <GrButton
              variant="secondary"
              onClick={handleOpenFilterDrawer}
              startIcon={<GrIcon icon={icons.filter} size="sm" />}
            >
              Filters
              {filterCount ? <GrCountBadge count={filterCount} sx={{ ml: gr.space[1] }} /> : null}
            </GrButton>
            <GrIconButton variant="close" aria-label="Close" onClick={handleCloseDialog1}>
              <GrIcon icon={icons.close} />
            </GrIconButton>
          </Box>
        </Box>

        <DialogContent
          sx={{
            overflow: "hidden",
            pt: 0,
            px: gr.space[6],
            "@media (max-width: 599.95px)": { px: gr.space[4] },
          }}
        >
          {isLoading ? (
            <GrLoader sx={{ py: gr.space[12] }} />
          ) : (
            <>
              <CustomDrawer
                isOpenDrawer={filterDrawerState}
                onOpenDrawer={handleOpenFilterDrawer}
                onCloseDrawer={handleCloseFilterDrawer}
                pageTitle="Filters"
                componentToPassDown={
                  <ExerciseFilter
                    filterData={filterState}
                    searchSubmitFilter={searchFunction}
                    handleClearFilter={handleClearFilter}
                    setFilterData={setFilterState}
                  />
                }
              />
              {exercise.length < 1 ? (
                <RecordNotFound title="Exercises" />
              ) : (
                <>
                  <Box sx={{ mb: gr.space[3] }}>
                    <GrFilterChips
                      ariaLabel="Sort exercises"
                      value={sortValue}
                      onChange={(value) => {
                        if (filterName === "") setSelectedTab(value);
                      }}
                      options={[
                        { value: tabs.asc, label: "A-Z" },
                        { value: tabs.close, label: "Z-A" },
                      ]}
                    />
                  </Box>

                  <InfiniteScroll
                    className="w-100"
                    dataLength={exercise.length}
                    next={fetchMoreData}
                    height="calc(100vh - 220px)"
                    hasMore={exercise.length < totalCount}
                    loader={<GrLoader sx={{ py: gr.space[4] }} />}
                  >
                    <Box sx={gridSx}>
                      {exercise.map((x, i) => (
                        <GrMediaCard
                          key={x?._id || i}
                          as="div"
                          image={x?.image?.thumbnail_1 ? s3baseUrl + x.image.thumbnail_1 : null}
                          placeholderIcon={icons.taskWorkout}
                          title={htmlDecode(x?.title)}
                          onClick={() => handleSelectExercise(x)}
                        />
                      ))}
                    </Box>
                  </InfiniteScroll>
                </>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ToshowExercise;
